// extracted by mini-css-extract-plugin
export default {"modal":"Notifier_modal__EX+AP","slideAcross":"Notifier_slideAcross__DecdK"};